import { FilesPickerInput } from "./FilesPickerInput.js";
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
import { castArray } from "lodash-es";
import { Field, useFormikContext } from "formik";
// src/modules/Files/shared/FormikFilesPicker.tsx
var FormikFilesPicker = ({ multi = true, name, ...props }) => {
	const form = useFormikContext();
	const [uploadComplete, setUploadComplete] = useState(true);
	function validateFileUploading() {
		let error;
		if (!uploadComplete) error = "file upload in-progress";
		return error;
	}
	return /* @__PURE__ */ jsx(Field, {
		name,
		validate: validateFileUploading,
		children: ({ field }) => {
			return /* @__PURE__ */ jsx("div", {
				className: "d-flex justify-content-between",
				onClick: () => form.setTouched({ [name]: true }),
				children: /* @__PURE__ */ jsx(FilesPickerInput, {
					...props,
					onChangeValue: (fileUrls) => {
						if (multi) form.setFieldValue(name, fileUrls);
						else form.setFieldValue(name, fileUrls[0]);
					},
					onSetPrimaryImage: (url) => form.setFieldValue("primaryImageUrl", url),
					previouslyUploadedFileUrls: field.value ? castArray(field.value) : [],
					multi,
					primaryImageUrl: form?.values?.primaryImageUrl,
					onUploadsComplete: setUploadComplete,
					subText: props.subText
				})
			});
		}
	});
};
export { FormikFilesPicker };

//# sourceMappingURL=FormikFilesPicker.js.map